import React from 'react';

/**
 * A count, attached to the thing it counts.
 *
 * The dashboard used to open with a row of four metric cards — big numbers in
 * boxes, disconnected from the tables that actually contained those rows. They
 * took the top of the screen (the most valuable space on the page) to report
 * figures nobody can act on, and pushed the real work below the fold.
 *
 * The number is more useful sitting next to its own list, where it reads as a
 * property of that list rather than a headline. Tabular figures so the width
 * doesn't jitter when the count changes.
 */
const CountChip = ({ count, tone = 'neutral', className = '' }) => {
  if (count === null || count === undefined) return null;

  const tones = {
    neutral: 'bg-muted text-muted-foreground',
    // For counts that represent work owed, not just volume.
    attention: 'bg-accent-subtle text-accent',
    urgent: 'bg-error-subtle text-error',
  };

  return (
    <span
      className={`inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 text-[11px] font-semibold tabular-nums ${
        tones[tone] || tones.neutral
      } ${className}`.trim()}
    >
      {count}
    </span>
  );
};

export default CountChip;
